import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError, filter, switchMap, take, timeout } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';

export class HttpLanguageLoader implements TranslateLoader {
  constructor(
    private httpClient: HttpClient,
    private authenticationService: AuthenticationService
  ) {}

  getTranslation(
    lang: string,
    localizationSubdirectory: string = 'static-translations'
  ): Observable<any> {
    return this.authenticationService.Authenticated.pipe(
      filter((value) => !!value),
      take(1),
      switchMap(() =>
        this.authenticationService.getAuthToken().pipe(timeout(10000))
      ),
      switchMap((token) => {
        if (!token || !token.AccessToken) {
          return throwError(
            () =>
              new Error(
                '[HttpLanguageLoader] Missing access token for translation request'
              )
          );
        }
        return this.callApi(lang, token, localizationSubdirectory).pipe(
          timeout(30000)
        );
      }),
      catchError((err) => {
        console.error('[HttpLanguageLoader] Failed to load translations:', err);
        return of({});
      })
    );
  }

  /**
   * Gets the proper translations from the api.
   */
  private callApi(
    lang: string,
    token: any,
    localizationSubdirectory: string = 'static-translations'
  ) {
    let url = environment.apiUrl;
    url = url.endsWith('/') ? url : url + '/';
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${token.AccessToken}`
    );
    const endpoint =
      url + 'localization/' + localizationSubdirectory + '?locale=' + lang;
    return this.httpClient.get(endpoint, {
      headers: headers,
      withCredentials: true,
    });
  }
}
